export default {
  ApiBaseUrl: 'https://api.debbieprint.weiswiseapps.com/api',
  serverBaseUrl: 'https://api.debbieprint.weiswiseapps.com',
}
